import { useMutation } from "@tanstack/react-query";
import { useCallback, useContext } from "react";
import { OrderRepositoryImpl } from "../../domain/orderRepositoryImpl/OrderRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";
import { queryKey as getOrderSummaryForCheckout } from "./useGetOrderSummaryForCheckout";

const orderRepo = OrderRepositoryImpl.getInstance();

const useDiscardPromo = () => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const mutation = useMutation(
    {
      mutationFn: () => {
        return orderRepo.discardPromo(auth, apiUrl);
      },
    },
    queryClient,
  );

  const discardPromo = useCallback(
    (onSuccess: () => void, onError: () => void) => {
      mutation.mutate(undefined, {
        onSuccess: () => {
          queryClient?.invalidateQueries({
            queryKey: [getOrderSummaryForCheckout],
          });
          onSuccess();
        },
        onError: () => {
          onError();
        },
      });
    },
    [mutation, queryClient],
  );

  return discardPromo;
};

export { useDiscardPromo };
